import { useEffect, useState } from "react";
import AdminGate from "@/components/AdminGate";
import PageHeader from "@/components/PageHeader";
import { useSeo } from "@/lib/seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminOrders() {
  useSeo({ title: "Admin · Orders | Cool Runnings Cape Town", noindex: true });
  return (
    <AdminGate>
      <OrdersTable />
    </AdminGate>
  );
}

function OrdersTable() {
  const [orders, setOrders] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${API}/admin/orders`, { credentials: "include" })
      .then(async (r) => {
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          throw new Error(err.detail || "Could not load orders");
        }
        return r.json();
      })
      .then(setOrders)
      .catch((e) => setError(e.message || "Could not load orders"));
  }, []);

  return (
    <section className="pb-24 pt-10 sm:pt-14" data-testid="admin-orders-page">
      <PageHeader
        tight
        pageName="Admin"
        eyebrow="Staff portal · shop"
        title="ORDERS"
        subline="Every checkout created on the site — paid, pending or failed."
        image="/admin-header.jpg"
      />
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        {error && <p className="mt-10 text-sm font-bold text-[#d63a2f]" data-testid="admin-orders-error">{error}</p>}

        {orders && orders.length === 0 && (
          <p className="card-dark mt-10 p-6 text-sm text-[#b9b4a6]" data-testid="admin-orders-empty">No orders yet.</p>
        )}

        {orders && orders.length > 0 && (
          <div className="card-dark mt-10 overflow-x-auto rounded-2xl border border-[#241c0d]/10" data-testid="admin-orders-table">
            <table className="w-full min-w-[720px] text-left text-sm">
              <thead>
                <tr className="border-b border-[#241c0d]/10 text-[11px] uppercase tracking-widest text-[#8a7b5e]">
                  <th className="px-4 py-3">Code</th>
                  <th className="px-4 py-3">Buyer</th>
                  <th className="px-4 py-3">Items</th>
                  <th className="px-4 py-3">Total</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Placed</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.code} className="border-b border-[#241c0d]/10 text-[#241c0d]" data-testid={`admin-order-row-${o.code}`}>
                    <td className="px-4 py-3 font-extrabold text-[#f8b818]">{o.code}</td>
                    <td className="px-4 py-3">
                      {o.name}
                      <br />
                      <span className="text-xs text-[#8a7b5e]">{o.email}</span>
                    </td>
                    <td className="px-4 py-3 text-xs">{(o.items || []).map((i) => `${i.qty}× ${i.name}`).join(", ")}</td>
                    <td className="px-4 py-3 font-extrabold">R{o.total}</td>
                    <td className="px-4 py-3">
                      <span
                        className={`chip !px-2 !py-0.5 !text-[10px] ${o.status === "PAID" ? "!border-green-600/50 !text-green-600" : "text-[#8a7b5e]"}`}
                        data-testid={`admin-order-status-${o.code}`}
                      >
                        {o.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-xs text-[#8a7b5e]">{(o.created_at || "").slice(0, 16).replace("T", " ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}
